import { ReactNode, useMemo } from 'react'
import { enableSideNavigation } from '../../featureFlags'
import { useSetHeaderBreadcrumbs } from '../Navigation/HeaderBreadcrumbsContext'
import {
  DocumentExchangeBreadcrumbs,
  DocumentExchangeBreadcrumbsProps,
} from './DocumentExchangeBreadcrumbs'
import { Surface } from '../common/Surface'

/**
 * Registers DocumentExchangeBreadcrumbs in the header when side navigation is
 * enabled and returns an inline fallback element for when it is not.
 */
export function useDocumentExchangeHeaderBreadcrumbs(
  props: DocumentExchangeBreadcrumbsProps
): ReactNode {
  const { projectBreadcrumbProps, siteBreadcrumbProps, checklistCategory } =
    props
  const { customerRFPName, isCustomerRFPNamePending } = projectBreadcrumbProps
  const { customerRFPId, siteRFPId, siteRFPName, isSiteRFPNamePending } =
    siteBreadcrumbProps ?? {}

  const headerBreadcrumbs = useMemo(
    () =>
      enableSideNavigation ? (
        <DocumentExchangeBreadcrumbs
          projectBreadcrumbProps={{ customerRFPName, isCustomerRFPNamePending }}
          siteBreadcrumbProps={
            customerRFPId !== undefined
              ? {
                  customerRFPId,
                  siteRFPId,
                  siteRFPName,
                  isSiteRFPNamePending: isSiteRFPNamePending ?? false,
                }
              : undefined
          }
          checklistCategory={checklistCategory}
        />
      ) : null,
    [
      customerRFPName,
      isCustomerRFPNamePending,
      customerRFPId,
      siteRFPId,
      siteRFPName,
      isSiteRFPNamePending,
      checklistCategory,
    ]
  )
  useSetHeaderBreadcrumbs(headerBreadcrumbs)

  if (enableSideNavigation) {
    return null
  }

  return (
    <Surface>
      <DocumentExchangeBreadcrumbs
        projectBreadcrumbProps={projectBreadcrumbProps}
        siteBreadcrumbProps={siteBreadcrumbProps}
        checklistCategory={checklistCategory}
      />
    </Surface>
  )
}
